import { render } from "./MeetingCard.vue?vue&type=template&id=2b81f1c4"
import script from "./MeetingCard.vue?vue&type=script&lang=js"
export * from "./MeetingCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-client/megaluzz-client/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__